import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("cs_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { localStorage.removeItem("cs_token"); setUser(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("cs_token", data.token);
    setUser(data.user);
  };
  const logout = () => { localStorage.removeItem("cs_token"); setUser(false); };

  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
